module.exports = __webpack_public_path__ + "static/media/warning-red-small-2.715086f7.svg";